import { i18n as _i18n } from "@lingui/core";
import { CarleadCreationButton, CarleadCreationForm, CarleadMileageFormatted, CarleadVinNotRecognized, defaultCarleadSplitFlow, EmailConsent, QuestionnaireBoxSelect, QuestionnaireSelect, renderFieldVerticalWrapper, SplitBodyTypes, SplitBuiltDates, SplitDoorCount, SplitFuelType, SplitGearType, SplitHorsePower, SplitMainTypeDetails, SplitMainTypes, SplitMainTypesSub, SplitManufacturers, useCreateCarleadChainedRequest, useCreateConsumerCarleadRequestChain, useCreateEmailConsentProps, useCreateNormalCarleadForm, useFormQuestionnaireProps, useSplitFieldsFlowService, useSplitFieldsProps } from '@wkda/carlead-creation-components';
import { useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import CarleadProgress from '../../../../../components/carlead/CarleadProgress';
import TermsAndConditions from '../../../../../components/carlead/TermsAndConditions';
import EmailWithTracking from '../../../../../components/carlead/EmailWithTracking';
import { carleadQuestionnaireWithBoughtOrOrderedCarQuestionPartialFlow } from '../../../../../constants/carlead/carleadQuestionnaireWithBoughtOrOrderedCarQuestionPartialFlow';
import { useBoughtOrOrderedCarValidation } from '../../../../../hooks/useBoughtOrOrderedCarValidation';
import { useMinimumMileageValidation } from '../../../../../hooks/useMinimumMileageValidation';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CAR_MILEAGE_LOWER_THRESHOLD = 2500;
const CAR_MILEAGE_UPPER_THRESHOLD = 35000;
const SUSPICIOUS_MILEAGE_MESSAGE_DELAY = 2000;
export default function CarleadStepCompoundBoughtOrOrderedCarConsent({
  showVinError = false
}) {
  const flow = {
    ...defaultCarleadSplitFlow,
    ...carleadQuestionnaireWithBoughtOrOrderedCarQuestionPartialFlow
  };
  const emailConsentProps = useCreateEmailConsentProps();
  const mileageProps = useMinimumMileageValidation();
  const boughtOrOrderedCarProps = useBoughtOrOrderedCarValidation();
  const questionnaireProps = useFormQuestionnaireProps(flow);
  const splitFieldsProps = useSplitFieldsProps();
  const machine = useSplitFieldsFlowService(flow);
  const request = useCreateCarleadChainedRequest([useCreateConsumerCarleadRequestChain()]);
  const consumerForm = useCreateNormalCarleadForm([
  // before questionnaireProps on purpose: validators compose right-to-left, first entry wins
  boughtOrOrderedCarProps, questionnaireProps, emailConsentProps, splitFieldsProps, mileageProps]);
  useTrackLanding();
  return /*#__PURE__*/_jsx(Paper, {
    className: "carlead-creation-form__container",
    children: /*#__PURE__*/_jsxs("div", {
      className: "container",
      children: [showVinError ? /*#__PURE__*/_jsx(CarleadVinNotRecognized, {
        className: "text-center mx-auto"
      }) : null, /*#__PURE__*/_jsxs(CarleadCreationForm, {
        carleadForm: consumerForm,
        options: {
          name: 'StepCompound'
        },
        machineService: machine,
        submitHandler: request,
        children: [/*#__PURE__*/_jsx(SplitManufacturers, {}), /*#__PURE__*/_jsx(SplitMainTypes, {}), /*#__PURE__*/_jsx(SplitBuiltDates, {}), /*#__PURE__*/_jsx(SplitBodyTypes, {
          isHiddenField: true
        }), /*#__PURE__*/_jsx(SplitFuelType, {
          isHiddenField: true
        }), /*#__PURE__*/_jsx(SplitMainTypeDetails, {
          isHiddenField: true
        }), /*#__PURE__*/_jsx(SplitHorsePower, {
          isHiddenField: true
        }), /*#__PURE__*/_jsx(SplitGearType, {
          isHiddenField: true
        }), /*#__PURE__*/_jsx(SplitDoorCount, {
          isHiddenField: true
        }), /*#__PURE__*/_jsx(SplitMainTypesSub, {
          isHiddenField: true
        }), /*#__PURE__*/_jsx(CarleadMileageFormatted, {
          lowerThreshold: CAR_MILEAGE_LOWER_THRESHOLD,
          upperThreshold: CAR_MILEAGE_UPPER_THRESHOLD,
          suspiciousMileageMessageDelay: SUSPICIOUS_MILEAGE_MESSAGE_DELAY,
          isHiddenField: true,
          renderFieldWrapper: renderFieldVerticalWrapper
        }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
          renderFieldWrapper: renderFieldVerticalWrapper,
          name: "SELLPOINT",
          label: _i18n._(
          /*i18n*/
          {
            id: 'carleadCreation.form.label.sellpoint'
          }),
          isHiddenField: true,
          answers: [{
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.sellpointNow'
            }),
            value: 'SELLPOINT_NOW'
          }, {
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.sellpoint4weeks'
            }),
            value: 'SELLPOINT_4_WEEKS'
          }, {
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.sellpoint3months'
            }),
            value: 'SELLPOINT_3_MONTHS'
          }, {
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.sellpointNotPlanned'
            }),
            value: 'SELLPOINT_NOT_PLANNED'
          }]
        }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
          renderFieldWrapper: renderFieldVerticalWrapper,
          name: "SELL_TYPES",
          label: _i18n._(
          /*i18n*/
          {
            id: 'carleadCreation.form.label.sellTypes'
          }),
          isHiddenField: true,
          answers: [{
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.sellTypesPrivate'
            }),
            value: 'PRIVATE'
          }, {
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.sellTypesDealer'
            }),
            value: 'DEALER'
          }]
        }), /*#__PURE__*/_jsx(QuestionnaireBoxSelect, {
          renderFieldWrapper: renderFieldVerticalWrapper,
          name: "BUY_CAR",
          isHiddenField: true,
          label: _i18n._(
          /*i18n*/
          {
            id: 'carleadCreation.form.label.buyCar'
          }),
          answers: [{
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.buyCarYES'
            }),
            value: 'YES'
          }, {
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.buyCarNO'
            }),
            value: 'NO'
          }]
        }), /*#__PURE__*/_jsx(QuestionnaireBoxSelect, {
          renderFieldWrapper: renderFieldVerticalWrapper,
          name: "BOUGHT_OR_ORDERED_CAR",
          isHiddenField: true,
          label: _i18n._(
          /*i18n*/
          {
            id: 'carleadCreation.form.label.boughtOrOrderedCar'
          }),
          answers: [{
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.buyCarYES'
            }),
            value: 'YES'
          }, {
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.option.buyCarNO'
            }),
            value: 'NO'
          }]
        }), /*#__PURE__*/_jsx(EmailWithTracking, {}), /*#__PURE__*/_jsx(EmailConsent, {
          isHiddenField: true
        }), /*#__PURE__*/_jsx(CarleadProgress, {}), /*#__PURE__*/_jsx(TermsAndConditions, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {})]
      })]
    })
  });
}